import type { SanityImageProps } from '@veranda/shared/sanity/utils/fragments/image-fragment';
import { CustomLink } from '../../components/custom-link';
import { cn } from '../../lib/utils';
import { SanityImage } from '../../sanity/utils/components/sanity-image';

interface CartEmptyItem {
  _key: string;
  title: string;
  slug: string;
  image: SanityImageProps | null;
}

export function CartEmptyItems({
  items,
  className,
  onClick,
}: {
  items: CartEmptyItem[];
  className?: string;
  onClick?: () => void;
}) {
  if (!items || items.length === 0) return null;

  return (
    <main className={cn('grid w-full grid-cols-1 gap-2', className)}>
      {items.map((item) => (
        <CustomLink
          key={item._key}
          href={item.slug}
          onClick={onClick}
          className="group/link grid grid-flow-dense grid-cols-[auto_1fr] items-center gap-3 border border-[hsl(var(--color))]/20 p-2 text-left"
        >
          {item.image && (
            <div className="relative h-10 w-10 overflow-hidden rounded-full">
              <SanityImage
                image={item.image}
                className="h-full w-full select-none rounded-full object-cover"
                fill
                sizes="40px"
              />
            </div>
          )}
          <div className="group-hover/link:underline">
            <h5 className="font-semibold text-[hsl(var(--color))]">
              {item.title}
            </h5>
          </div>
        </CustomLink>
      ))}
    </main>
  );
}
